import './style.css'
import * as THREE from 'three'
// import * as dat from 'lil-gui'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'

const textureLoader = new THREE.TextureLoader()
//  const matcapTexture = textureLoader.load('/textures/matcaps/3B3B3B_C7C7C7_878787_A4A4A4.jpg')
const matcapTexture1 = textureLoader.load('assets/natale/textures/matcaps/ice7.jpg')



/**
 * Sizes
 */
 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

const parameters = {}
parameters.count = 8000
parameters.size = 0.01
parameters.radius = 3.5
parameters.branches = 11
parameters.spin = 4.40
parameters.camx = -2
parameters.camy = -2
parameters.camz = 4

// parallax
const cursor = {}
cursor.x = 0
cursor.y = 0




let geometry = null
let material = null
let points = null



const groupfiocchi = new THREE.Group();
// LOADER
const gltfLoader = new GLTFLoader()
let fioccogeom = null
gltfLoader.load(
    'assets/natale/models/fiocco.glb',
    (glb)=>{
        // console.log(glb.scene.children[0])
        fioccogeom = glb.scene.children[0].geometry
        const fioccoMaterial = new THREE.MeshMatcapMaterial()
        fioccoMaterial.matcap = matcapTexture1
        
        // console.time('donuts')
         for (let i = 0; i < 300; i++){
            
        const fiocco = new THREE.Mesh(fioccogeom,fioccoMaterial)
             fiocco.position.x = (Math.random() -0.5) * 10 + parameters.camx
             fiocco.position.y = (Math.random() -0.5) * 10
             fiocco.position.z = (Math.random() -0.5) * 10
             fiocco.rotation.x = Math.random() * Math.PI
             fiocco.rotation.y = Math.random() * Math.PI
            
             const size = 0.003//Math.random() / 8
            //  console.log(size)
             fiocco.scale.x = size
             fiocco.scale.y = size
             fiocco.scale.z = size
        //     // console.log(donut)
        groupfiocchi.add(fiocco)
        }
        scene.add(groupfiocchi)
        // scene.add(glb.scene.children[0]) // importa primo figlio della scena nel file
    },
    ()=>{console.log('prog')},
    ()=>{console.log('ko')}
    )
// console.log(gltfLoader)

 
/**
 * Base
 */
// Debug
// const gui = new dat.GUI()
// gui.close()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
let particles = null
/**
 * Fog
 */
const fog = new THREE.Fog('#601', 1, 15)
scene.fog = fog
 
 

/**
 * Objects
 */

// const group = new THREE.Group();

// const cube1 = new THREE.Mesh(
//     new THREE.BoxGeometry(1,1,1),
//     new THREE.MeshBasicMaterial({color:'#f00'})
// )

// const cube2 = new THREE.Mesh(
//     new THREE.BoxGeometry(1,1,1),
//     new THREE.MeshBasicMaterial({color:'#090'})
// )
// cube2.position.x = 2

// const cube3 = new THREE.Mesh(
//     new THREE.BoxGeometry(1,1,1),
//     new THREE.MeshBasicMaterial({color:'#03c'})
// )
// cube3.position.x = -2

// group.rotateX(12)
// group.rotateZ(12)

// group.add(cube1)
// group.add(cube2)
// group.add(cube3)
// scene.add(group)


// const axesHelper = new THREE.AxesHelper(3)
// scene.add(axesHelper)
// mesh.position.normalize()

/**
 * Camera
 */
 const cameragroup = new THREE.Group()
 scene.add(cameragroup)

//  cameragroup.position.x = 0
 
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.x = parameters.camx
camera.position.y = parameters.camy
camera.position.z = parameters.camz
cameragroup.add(camera)

//  scene.add(camera)

const generate = () => {

    if (points !== null) {
        geometry.dispose()
        material.dispose()
        particlesGeom.dispose()
        particleMat.dispose()
        scene.remove(points)
        particles.remove(points)
    }
    console.log("genera")
    

    geometry = new THREE.BufferGeometry()
    const positions = new Float32Array(parameters.count*3)
    for (let i = 0; i  < parameters.count; i++) {
        const i3 = i*3

        const radius = Math.random() * parameters.radius
        const spinAngle = radius * parameters.spin
        // genera angolo  diviso il numero di bracci
        const branchangle = (i % parameters.branches) / parameters.branches * Math.PI * 2


        positions[i3] = Math.cos(branchangle + spinAngle) * radius + ((Math.random()-0.5)*0.1) 
        positions[i3 + 1] = 0 - radius*3 + (Math.random()*0.2)
        positions[i3 + 2] = Math.sin(branchangle + spinAngle) * radius 
        // console.log(Math.random())
        // console.log(positions[i3],positions[i3 + 1],positions[i3 + 2])
        // if (i < parameters.branches ) console.log(branchangle)
    }
    
    geometry.setAttribute('position', new THREE.BufferAttribute(positions,3))
    // console.log(positions)

    // camera.lookAt(geometry.attributes.position)
    // console.log('88',camera.position)
    // console.log('89',geometry.attributes.position)

    material = new THREE.PointsMaterial({
        size: parameters.size, 
        sizeAttenuation: true, 
        depthWrite:false, 
        blending: THREE.AdditiveBlending
    })

    points = new THREE.Points(geometry, material)
    scene.add(points)


    // particles
    const PartCount = 4000
    const starspositions = new Float32Array(PartCount*3)

     for (let i = 0; i < PartCount; i++) {
         starspositions[i *3 + 0 ] = (Math.random() - 0.5) *20 -3
         starspositions[i *3 + 1 ] = (Math.random() - 0.5) *10 // parameters.objectdistance * (Math.random() - 0.5) * parameters.objectdistance * sectionmeshes.length
         starspositions[i *3 + 2 ] =(Math.random() - 0.5) * 10 - 3
     }
    
    const particlesGeom = new THREE.BufferGeometry()
    particlesGeom.setAttribute('position',new THREE.BufferAttribute(starspositions,3))
    const particleMat = new THREE.PointsMaterial({
         color: '#fff',//parameters.materialColor,
         sizeAttenuation: true,
         size: 0.01
     })
     particles = new THREE.Points(particlesGeom,particleMat)
     scene.add(particles)

    // const fiocco = glb.scene.children[0].geometry
    // const fioccoGeometry = new THREE.TorusGeometry(0.1,0.1,25,25)
    // const fioccoMaterial = new THREE.MeshMatcapMaterial()

// console.time('donuts')
// for (let i = 0; i < 1000; i++){
//     donutMaterial.matcap = matcapTexture1
    //  const fiocco = new THREE.Mesh(fiocco.fioccoMaterial)
//     donut.position.x = (Math.random() -0.5) * 3
//     donut.position.y = (Math.random() -0.5) * 3
//     donut.position.z = (Math.random() -0.5) * 3
//     donut.rotation.x = Math.random() * Math.PI
//     donut.rotation.y = Math.random() * Math.PI
    
//     const size = Math.random() /3
//     donut.scale.x = size
//     donut.scale.y = size
//     donut.scale.z = size
//     // console.log(donut)
    //  scene.add(fiocco)
// }
// console.timeEnd('donuts')


}

// gui.add(parameters,'count').min(1).max(100000).step(100).onFinishChange(generate)
// gui.add(parameters,'size').min(0.001).max(0.1).step(0.001).onFinishChange(generate)
// gui.add(parameters,'radius').min(0.001).max(20).step(0.001).onFinishChange(generate)
// gui.add(parameters,'branches').min(1).max(20).step(1).onFinishChange(generate)
// gui.add(parameters,'spin').min(-5).max(5).step(0.01).onFinishChange(generate)
// gui.add(parameters,'camx').onFinishChange(generate)
// gui.add(parameters,'camy').onFinishChange(generate)
// gui.add(parameters,'camz').onFinishChange(generate)


generate()
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha:true
})
renderer.setSize(sizes.width, sizes.height)
renderer.render(scene, camera)

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

window.addEventListener('mousemove',(event) => {
    cursor.x = (event.clientX / sizes.width - 0.5) 
    cursor.y = (event.clientY / sizes.height - 0.5)
    //  console.log(cursor)
    // camera.position.set(cursor.x,cursor.y,0)
    // console.log(cameragroup)
})

// scroll
let scrollY = window.scrollY
window.addEventListener('scroll', () => {
    scrollY = window.scrollY
    console.log(scrollY)
})


/**
 * Animate
 */
 const clock = new THREE.Clock()
 let prevtime

 const tick = () =>
 {
     const elapsedTime = clock.getElapsedTime()
     const deltaTime = elapsedTime - prevtime
     prevtime = elapsedTime
 


    // PARALLAX
     const parallaxX = cursor.x
     const parallaxY = - cursor.y
    //  console.log(cameragroup)
        
    //  cameragroup.position.y += (parallaxY - cameragroup.position.y) * 5 * deltaTime
    // console.log(cameragroup.position.x)
    cameragroup.position.x = parallaxX
    cameragroup.position.y = parallaxY 

    //  cameragroup.position.x += (parallaxX - cameragroup.position.x) * 5 * deltaTime
    //  cameragroup.position.y += (parallaxY - cameragroup.position.y) * 5 * deltaTime
    // console.log('elapse',elapsedTime)
    if (elapsedTime<60) {
            cameragroup.position.z = cameragroup.position.z +(elapsedTime/200000)
        } else {
            cameragroup.position.z = cameragroup.position.z -(elapsedTime/200000)
    }
    if (elapsedTime>120) {cameragroup.position.z = 0}
     // Update controls
     //  controls.update()
 
     //  console.log(camera.position)
     groupfiocchi.position.y -= 0.0001
     groupfiocchi.rotation.y += 0.00001
 
     points.rotation.y += 0.002
     particles.rotation.z += 0.0001
     // Render
     renderer.render(scene, camera)
 
     // Call tick again on the next frame
     window.requestAnimationFrame(tick)
 }
 
 tick()


